import "./videoButton.scss";
import { ReactComponent as PlayIcon } from "static/icons/play.svg";
import * as utils from "shell/app/app.utils";

interface videoButtonProps {
  onVideoOpen: () => void;
  videoButtonLabel: string;
}

const VideoButton: React.FC<videoButtonProps> = (props) => (
  <div className="video-play">
    <button className="video-play-button" onClick={props.onVideoOpen}>
      <div className="video-play-button__inner">
        <img src={utils.assetPath("/images/video-poster.jpg")} className="video-play-button__image" alt=""/>
        <div className="video-play-button__play">
          <PlayIcon />
        </div>
      </div>
      <div className="video-play__label">{props.videoButtonLabel}</div>
    </button>
  </div>
);

export default VideoButton;
